import { useState } from "react";
import { Divider, Card } from "antd";
import {
  IoMdReturnLeft,
  IoMdInformationCircle,
  IoMdSettings,
  IoMdEye,
  IoMdEyeOff,
  IoMdAddCircle,
} from "react-icons/io";
import "./detail-channel-screen.scss";
import Button from "src/libraries/components/button/Button";
import { PaymentChannel } from "src/libraries/types/channel";
interface DetailProps {
  data: PaymentChannel;
  handleCancel: () => void;
}

interface VisibilityState {
  [key: string]: boolean;
}
export const DetailChannelScreen = ({ data, handleCancel }: DetailProps) => {
  const [visibilityState, setVisibilityState] = useState<VisibilityState>({
    key1: true,
    key2: true,
    key3: true,
  });

  const toggleVisibility = (key: string) => {
    setVisibilityState({
      ...visibilityState,
      [key]: !visibilityState[key],
    });
  };
  return (
    <div>
      <div className="detail-channel-screen">
        <div className="back-channel">
          <Button
            className="back-button"
            background="#022e45"
            textColor="#FFF"
            borderColor="#022e45"
          >
            <div className="button-content" onClick={() => handleCancel()}>
              <i>
                <IoMdReturnLeft color="#fff" size={24} />
              </i>
              <p className="button-text">Quay lại</p>
            </div>
          </Button>
        </div>
        <div className="top-channel-detail">
          <div className="channel-detail-info">
            <div className="account-item">
              <div className="account-img">
                <img
                  alt="Bank logo"
                  loading="lazy"
                  src="https://img.bankhub.dev/rounded/mbbank.png"
                />
              </div>
              <div className="account-name">
                <div className="account-merchant">{data.channelName}</div>
              </div>
              <div className="account-state">
                <div>Đang hoạt động</div>
              </div>
            </div>
          </div>
          <div className="channel-more-info">
            <div className="channel-setting">
              <IoMdInformationCircle />
              <div>Thông tin tích hợp</div>
            </div>
            <div className="channel-setting">
              <IoMdSettings />
              <div>Cài đặt</div>
            </div>
          </div>
        </div>
        <Divider />
        <div className="bottom-channel-detail">
          <Card className="left-channel-card" title="Thông tin cấu hình">
            <div className="channel-keys">
              <div className="key-item">
                <div className="key-title">Client ID</div>
                {visibilityState.key1 ? (
                  <div className="key-secret">
                    <span>{data.clientId.replace(/./g, "•")}</span>
                    <IoMdEyeOff onClick={() => toggleVisibility("key1")} />
                  </div>
                ) : (
                  <div className="key-secret">
                    <span>{data.clientId}</span>
                    <IoMdEye onClick={() => toggleVisibility("key1")} />
                  </div>
                )}
              </div>
              <div className="key-item">
                <div className="key-title">API Key</div>
                {visibilityState.key2 ? (
                  <div className="key-secret">
                    <span>{data.apiKey.replace(/./g, "•")}</span>
                    <IoMdEyeOff onClick={() => toggleVisibility("key2")} />
                  </div>
                ) : (
                  <div className="key-secret">
                    <span>{data.apiKey}</span>
                    <IoMdEye onClick={() => toggleVisibility("key2")} />
                  </div>
                )}
              </div>
              <div className="key-item">
                <div className="key-title">Checksum Key</div>
                {visibilityState.key3 ? (
                  <div className="key-secret">
                    <span>{data.checkSum.replace(/./g, "•")}</span>
                    <IoMdEyeOff onClick={() => toggleVisibility("key3")} />
                  </div>
                ) : (
                  <div className="key-secret">
                    <span>{data.checkSum}</span>
                    <IoMdEye onClick={() => toggleVisibility("key3")} />
                  </div>
                )}
              </div>
            </div>
          </Card>
          <Card className="right-channel-card" title="Ngân hàng">
            <div className="channel-detail-bank">
              <div className="bank-detail-logo">
                <img
                  alt="Bank logo"
                  loading="lazy"
                  src="https://img.bankhub.dev/rounded/mbbank.png"
                />
              </div>
              <Divider />
              <div className="bank-detail-info">
                <div className="info-left">
                  <div className="info-title">{data.bank.bankAccountName}</div>
                  <div className="info-code">{data.bank.bankAccountNumber}</div>
                </div>
                <div className="info-right">
                  <div>Đang liên kết</div>
                </div>
              </div>
            </div>
            <div className="channel-sub-bank">
              <div className="add-sub-bank">
                <IoMdAddCircle />
                Thêm ngân hàng dự phòng
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
